import { useMemo } from 'react';
import { generateUniqueId } from '../../../hooks/use-unique-id';
export var useIds = function (_a) {
    var hasHighlightedOption = _a.hasHighlightedOption, hasSelectedOption = _a.hasSelectedOption;
    return {
        highlightedOptionId: useMemo(function () { return (hasHighlightedOption ? generateUniqueId() : undefined); }, [hasHighlightedOption]),
        selectedOptionId: useMemo(function () { return (hasSelectedOption ? generateUniqueId() : undefined); }, [hasSelectedOption]),
        menuId: useMemo(function () { return generateUniqueId(); }, [])
    };
};
//# sourceMappingURL=use-ids.js.map